import { Link } from '@playbooks/ui/components/link';
import { cn } from '@playbooks/ui/lib/utils';

export const CollectionCardMeta = ({ collection, className = '' }) => {
	// Theme
	const rootClassName = cn('flex-start flex-wrap py-1', className);

	// Render
	return (
		<div className={rootClassName}>
			{collection.language && (
				<span className='mr-4 text-sm text-foreground-body underline hover:text-foreground'>
					{collection.language?.name}
				</span>
			)}
			{collection.framework && (
				<span className='mr-4 text-sm text-foreground-body underline hover:text-foreground'>
					{collection.framework?.name}
				</span>
			)}
			{collection.tool && (
				<span className='mr-4 text-sm text-foreground-body underline hover:text-foreground'>
					{collection.tool?.name}
				</span>
			)}
			{collection.category && (
				<Link
					variant='secondary'
					href={`/explore/categories/${collection.category?.uuid}`}
					className='mr-4 text-sm text-foreground-body underline hover:text-foreground'>
					{collection.category?.name}
				</Link>
			)}
		</div>
	);
};
